import React from "react";
import successBg from "../../assets/booking_success_bg.png";
import { TCText } from "../../components/TCText/TCText";
import { Strings } from "../../utils/strings";
import { Button } from "../../components/button/Button";
import { Colors } from "../../utils/colors";
import { useNavigate } from "react-router-dom";
import {
  useCourtBookingStore,
  useMatchListStore,
  usePaymentStore,
  useSectionStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";
import { isIOS } from "react-device-detect";
import { IS_HIDE_TOP_BAR } from "../../utils/constants";

export const SuccessBooking = () => {
  const courtBookingStore = useCourtBookingStore();
  const sectionStore = useSectionStore();
  const paymentStore = usePaymentStore();
  const selectCircleStore = useSelectCircleStore();
  const matchListStore = useMatchListStore();

  const resetStates = () => {
    sectionStore.resetStore();
    courtBookingStore.resetStore();
    paymentStore.resetStore();
    selectCircleStore.resetStore();
    matchListStore.getMatchList();
  };
  const navigate = useNavigate();
  return (
    <div
      style={{
        backgroundColor: Colors.green,
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        height: isIOS
          ? localStorage.getItem(IS_HIDE_TOP_BAR)
            ? "100vh"
            : "90vh"
          : "100vh",
      }}>
      <div
        style={{
          backgroundImage: `url(${successBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: isIOS
            ? localStorage.getItem(IS_HIDE_TOP_BAR)
              ? "100vh"
              : "90vh"
            : "100vh",
          width: "100vw",
          maxWidth: "450px",
          display: "flex",
          flexDirection: "column-reverse",
        }}>
        <div
          style={{
            marginBottom: 20,
            paddingLeft: 30,
            paddingRight: 30,
            display: "flex",
            flexDirection: "column",
          }}>
          <TCText
            style={{
              fontWeight: 600,
              fontSize: 32,
              color: "white",
              textAlign: "center",
            }}
            value={Strings.THANKYOU_FOR_BOOKING}
          />
          <TCText
            style={{
              fontWeight: 400,
              fontSize: 12,
              color: "white",
              textAlign: "center",
              marginTop: 30,
            }}
            value={Strings.SUCCESS_BOOKING_CONTENT}
          />
          <Button
            onPress={() => {
              resetStates();
              if (localStorage.getItem(IS_HIDE_TOP_BAR) === "true") {
                navigate("/back-to-home", { replace: true });
              } else {
                navigate("/", { replace: true });
              }
            }}
            btnStyle={{
              width: 162,
              height: 56,
              backgroundColor: Colors.darkBrown,
              alignSelf: "center",
              marginTop: 30,
            }}
            textStyle={{ color: "white", fontWeight: 600, fontSize: 14 }}
            text="Back to home"
          />
        </div>
      </div>
    </div>
  );
};
